var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.777,
    viewBox: "0 0 18 17.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-delete",
    transform: "translate(-151.083 -514.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_176",
    "data-name": "Trac\\xE9 176",
    d: "M165.324,528.7v1.17a1.38,1.38,0,0,1-1.38,1.38h-1.171",
    fill: "none",
    stroke: "#e73c4c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 16,
    height: 2.48,
    rx: 1.153,
    transform: "translate(152.083 518.708)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_177",
    "data-name": "Trac\\xE9 177",
    d: "M160,531l-4.178.005-2.516-9.852h13.555l-1.258,4.961",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_129",
    "data-name": "Ligne 129",
    y1: 2.795,
    x2: 3.424,
    transform: "translate(154.494 515.88)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_130",
    "data-name": "Ligne 130",
    x1: 3.424,
    y1: 2.795,
    transform: "translate(162.215 515.88)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_131",
    "data-name": "Ligne 131",
    y2: 2.976,
    transform: "translate(157.254 524.857)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_132",
    "data-name": "Ligne 132",
    y2: 2.976,
    transform: "translate(160.048 524.857)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_133",
    "data-name": "Ligne 133",
    y2: 2.976,
    transform: "translate(162.843 524.857)",
    fill: "none",
    stroke: "#445aa5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.f393ae573d82f4ee37c55c907cccc0f3.svg";
export { ForwardRef as ReactComponent };